import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Typography } from '@mui/material';

import { openSpotlight } from '../Spotlight/Spotlight';

export default function SpotlightSearchButton() {
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
  const shortcutLabel = isMac ? '⌘K' : 'Ctrl K';

  return (
    <Button
      color="inherit"
      fullWidth
      onClick={openSpotlight}
      startIcon={<SearchIcon />}
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        color: 'text.secondary',
        justifyContent: 'space-between',
        maxWidth: 520,
        px: 1.5,
        py: 0.75,
        textTransform: 'none',
      }}
    >
      <Box component="span" sx={{ flexGrow: 1, textAlign: 'left' }}>
        Search pages...
      </Box>
      <Typography
        component="span"
        variant="caption"
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          color: 'text.disabled',
          lineHeight: 1.4,
          px: 0.75,
        }}
      >
        {shortcutLabel}
      </Typography>
    </Button>
  );
}
